import { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router";
import { useMenuItemStore } from "store/menuItem";
import { findMenuItemByPath } from "utils/helper";
import { getPageAccessApi } from "api/menu";
import { PageAccessByMenu } from "interface/user";

// add doc
/**
 * Custom hook to manage page access and home page access.
 * It fetches the access rights for the current page and the home page items.
 * Note: homePageAccess  should be used only for the home page  path  "/",
 * @returns {Object} - Contains pageAccess, homePageAccess, and loading state.
 */
export const usePageAccess = () => {
	const [pageAccess, setPageAccess] = useState<PageAccessByMenu | null>(null);

	const [loading, setLoading] = useState(true);
	const location = useLocation();
	const { menuItems } = useMenuItemStore();
	const { path } = useParams();
	let currentPath = location.pathname;
	useEffect(() => {
		setLoading(true);
		const pageHandler = async () => {
			try {
				const menu = findMenuItemByPath(menuItems, path || "/");

				if (menu) {
					const access = await getPageAccessApi(menu.id);
					setPageAccess(access);
				}
			} catch (error) {
				console.error("Error fetching page access:", error);
			} finally {
				setLoading(false);
				// isLoadingRef.current = false;
			}
		};
		pageHandler();
	}, [currentPath, menuItems]);

	return { pageAccess, loading };
};
